/**
 * Alverio theme bootstrap
 */
(function () {
  const settings = window.themeSettings || {};

  // Quick add buttons
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    const isIconBtn = btn.classList.contains('product-card__cart-btn');
    btn.disabled = true;

    if (isIconBtn) {
      btn.classList.add('is-loading');
    } else {
      btn.textContent = settings.strings?.loading || 'Loading...';
    }

    try {
      await window.Alverio.addToCart(variantId, 1);
      window.Alverio.publish('cart:updated');
      if (settings.cartType === 'drawer') {
        window.Alverio.publish('cart:open');
      }
      if (isIconBtn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
      } else {
        btn.textContent = settings.strings?.addToCart || 'Added';
      }
    } catch {
      if (!isIconBtn) {
        btn.textContent = settings.strings?.unavailable || 'Unavailable';
      }
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        if (isIconBtn) {
          btn.classList.remove('is-loading', 'is-added');
        } else {
          btn.textContent = 'Quick add';
        }
      }, 1500);
    }
  });

  // Scroll reveal
  if (settings.scrollReveal && !window.Alverio.prefersReducedMotion()) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.scroll-reveal').forEach((el) => observer.observe(el));
  }

  // Update cart count
  async function updateCartCount() {
    try {
      const cart = await window.Alverio.getCart();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
        const cartButton = el.closest('.header-actions__item--cart');
        if (cartButton) {
          cartButton.classList.toggle('has-items', cart.item_count > 0);
        }
      });
    } catch {
      /* noop */
    }
  }

  window.Alverio.subscribe('cart:updated', updateCartCount);
  updateCartCount();
})();
